var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c("h1", { staticClass: "title is-2" }, [
        _vm._v("\n    Editar usuario\n  "),
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("Formulario", {
        attrs: { model: _vm.model, error: _vm.error, edit: true },
        on: { submit: _vm.submit },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _c("p", [
        _vm._v("Edite los datos del usuario de la organización."),
        _c("br"),
        _vm._v(
          " Una vez que finalizó de cargar los datos, presione el botón\n    "
        ),
        _c("span", { staticClass: "tag is-primary" }, [_vm._v("Guardar")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }